<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-info" v-if="hasNoGPSDevices">No GPS devices found.</div>

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <GPSList
      :user="user"
      :gpsDevices="gpsDevices"
      :usersCacheStorePath="usersCacheStorePath"
      v-if="gpsDevicesLoaded"
      @gps-selected="gpsSelected($event)"
    />
  </div>
</template>

<script>
import Spinner from '@/components/utils/Spinner'
import GPSList from '@/modules/gps/GPSList'

import {
  LOAD_GPS_DEVICES,
  IS_LOADING_GPS_DEVICES,
  GET_GPS_DEVICES,
  GET_GPS_DEVICES_LOAD_ERROR,
  HAS_EMPTY_GPS_DEVICES_LOAD_RESULT
} from './userStore'

import { SET_GPS } from '@/modules/gps/gpsDeviceStore.js'

export default {
  name: 'UserGPSDevicesTab',

  components: {
    GPSList,
    Spinner
  },

  props: {
    user: {
      type: Object,
      required: true
    },

    userStorePath: {
      type: String,
      required: true
    },

    selectedGPSStorePath: {
      type: String,
      required: true
    },

    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  mounted() {
    const loadGPSDevicesAction = `${this.userStorePath}/${LOAD_GPS_DEVICES}`
    this.$store.dispatch(loadGPSDevicesAction)
  },

  computed: {
    gpsDevicesLoaded() {
      return this.gpsDevices !== null
    },

    isLoading() {
      const isLoadingGPSDevices = `${this.userStorePath}/${IS_LOADING_GPS_DEVICES}`
      return this.$store.getters[isLoadingGPSDevices]
    },

    hasNoGPSDevices() {
      const hasEmptyGPSDevicesLoadResult = `${this.userStorePath}/${HAS_EMPTY_GPS_DEVICES_LOAD_RESULT}`
      return this.$store.getters[hasEmptyGPSDevicesLoadResult]
    },

    gpsDevices() {
      const getGPSDevices = `${this.userStorePath}/${GET_GPS_DEVICES}`
      return this.$store.getters[getGPSDevices]
    },

    loadError() {
      const getGPSDevicesLoadError = `${this.userStorePath}/${GET_GPS_DEVICES_LOAD_ERROR}`
      return this.$store.getters[getGPSDevicesLoadError]
    }
  },

  methods: {
    gpsSelected(gps) {
      const setGPSAction = `${this.selectedGPSStorePath}/${SET_GPS}`
      this.$store.dispatch(setGPSAction, { gps })

      const deviceId = gps.deviceId
      this.$router.push({ name: 'userDetailsGPS', params: { deviceId }, query: this.$route.query })
    }
  }
}
</script>
